import moment from 'moment';

// Get tomorrow at midnight so that default endtime
// is inclusive of today
export default (date: moment.MomentInput) => moment(date).endOf('day').local().toDate();
